import { getAppConfigSingleton } from "@expert/app-config";
import { getLogger } from "@expert/logging";
import type { AnalyticsEventModel, ExtendedEventData } from "@soluto-private/eventualize";
import { getSharedApiClient } from "@/shared-utils";

const logger = getLogger({ module: "Analytics" });

async function analyticsApiSink(eventModel: AnalyticsEventModel<ExtendedEventData>) {
    try {
        const partner = eventModel.context.extra.partner;
        const partnerEventWhitelist =
            partner && getAppConfigSingleton().getPartnersConfig(partner as string).partnerEventWhitelist;
        if (partnerEventWhitelist && !partnerEventWhitelist.includes(eventModel.eventData.name)) {
            logger.info(
                {
                    partner,
                    eventName: eventModel.eventData.name,
                },
                `Event is not in the whitelist for partner, skipping`,
            );
            return true;
        }

        await getSharedApiClient()
            .extend({ retry: 3 })
            .post("api/analytics/v1/dispatch", { searchParams: { name: eventModel.eventData.name }, json: eventModel });
        return true;
    } catch (error: unknown) {
        logger.error({ error }, "Unable to send analytics events after multiple tries");
        return false;
    }
}

export default analyticsApiSink;
